import { render } from "./FormDescription.vue?vue&type=template&id=929680ba&ts=true"
import script from "./FormDescription.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormDescription.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/form/FormDescription.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "929680ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('929680ba', __exports__)) {
    api.reload('929680ba', __exports__)
  }
  
  module.hot.accept("./FormDescription.vue?vue&type=template&id=929680ba&ts=true", () => {
    api.rerender('929680ba', render)
  })

}


export default __exports__